module.exports = __webpack_public_path__ + "static/media/blog-r-g.17a1b230.jpg";